"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../../styles/styles"));
const button_1 = __importDefault(require("../../button/button"));
const eventConstants_1 = require("../../../constants/eventConstants");
const GoBackComponent = ({ disabled, onPress }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterCenter, styles_1.default.marginTen] },
        react_1.default.createElement(button_1.default, { disabled: disabled, icon: free_solid_svg_icons_1.faArrowLeft, text: "Go Back", onPress: onPress, fill: true, eventName: eventConstants_1.NAVIGATE_GO_BACK_COMMUNICATION })));
};
GoBackComponent.defaultProps = {
    disabled: false,
};
exports.default = GoBackComponent;
